exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-66390e4d]{font-size:.85rem;border-top:0}tr.ticket-row[data-v-66390e4d]{border-left:8px solid;border-bottom:1px solid #ccc}tr.open[data-v-66390e4d]{border-left-color:#6fa551}tr.closed[data-v-66390e4d]{border-left-color:crimson}tr.waiting-list[data-v-66390e4d]{border-left-color:#ecb618}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66390e4d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/RegistrationCategories/Tickets/Table/Row.vue
// module id = 2189
// module chunks = 1